const defaultVoltageClasses = {
    AC: [
        {
            min: 0,
            max: 119,
            label: '0-120 V',
            color: '#FF6B6B',
        },
        {
            min: 120,
            max: 199,
            label: '120-200 V',
            color: '#FA5252',
        },
        {
            min: 200,
            max: 299,
            label: '200-300 V',
            color: '#F03E3E',
        },
        {
            min: 300,
            max: 499,
            label: '300-500 V',
            color: '#E03131',
        },
        {
            min: 500,
            max: 99999,
            label: '> 500 V',
            color: '#C92A2A',
        },
    ],
    DC: [
        {
            min: 0,
            max: 119,
            label: '0-120 V',
            color: '#4dabf7',
        },
        {
            min: 120,
            max: 299,
            label: '120-300 V',
            color: '#339af0',
        },
        {
            min: 300,
            max: 499,
            label: '300-500 V',
            color: '#228be6',
        },
        {
            min: 500,
            max: 999,
            label: '500-1000 V',
            color: '#1c7ed6',
        },
        {
            min: 1000,
            max: 1499,
            label: '1000-1500 V',
            color: '#1971c2',
        },
        {
            min: 1500,
            max: 99999,
            label: '>1500 V',
            color: '#1864ab',
        },
    ],
};

export { defaultVoltageClasses };
